import type { FaireProductEntity } from "../../entity_types/product";

export const p_2emndz4avz: FaireProductEntity = {
  token: "p_2emndz4avz",
  type: "product",
  name: "Infant Girls Pinky Pink Rose Baby Gown and Bow Headband",
  brandToken: "b_dlso2ccw88",
  brandName: "Adorable Sweetness",
  imageUrl:
    "https://cdn.faire.com/fastly/6293f44a4db0bb0c85b98463fda82aac057af38c7d66b804cb64f25234b6b01a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de39e87e96f8622de3359cdcb4ff534f1ceb40a23ad2ed2dd6fd13c1bb195aff.jpeg",
    "https://cdn.faire.com/fastly/a199da74ed776467a76a2c6b61ec076f79697a6212d71ced8b3fd6e199f07446.jpeg",
    "https://cdn.faire.com/fastly/a4573100a4d296ffdc7760cb4712cd24f1804c36f455604ce48f5c8d6be09d91.jpeg",
    "https://cdn.faire.com/fastly/ccf351e29348580533a150425b0a54ec3482eef75d4ff738b103789451617041.jpeg",
  ],
  priceDollars: 10,
  description:
    "Size is 0-3 Months\nIncludes a free matching headband!\n\nEnjoy this adorable pink rose print sleep gown for your precious new arrival. Our gowns are made of a quality 95% polyester and 5% spandex blend that leaves your babe feeling super soft & incredibly cozy. The sturdy elastic at the bottom allows parents quick access for diaper changes and will keep little toes tucked in during all hours of the day and night. \n",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:32.791Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
